import { render, staticRenderFns } from "./experiential-learning-modal.vue?vue&type=template&id=24dd4917&scoped=true"
import script from "./experiential-learning-modal.vue?vue&type=script&lang=js"
export * from "./experiential-learning-modal.vue?vue&type=script&lang=js"
import style0 from "./experiential-learning-modal.vue?vue&type=style&index=0&id=24dd4917&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dd4917",
  null
  
)

export default component.exports